const isLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const fallbackApiBase = isLocalHost
  ? `http://${window.location.hostname || "localhost"}:5000`
  : window.location.origin;

const fallbackWsBase = isLocalHost
  ? `ws://${window.location.hostname || "localhost"}:5000`
  : `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}`;

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || fallbackApiBase;
export const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || fallbackWsBase;

export const MAKE_GAME_URL = `${API_BASE_URL}/makeGameFile/`;
export const START_PAGE_WS_URL = `${WS_BASE_URL}/StartPageSocket`;
export const GAME_WS_URL = `${WS_BASE_URL}/GameSocket`;
export const CHAT_WS_URL = `${WS_BASE_URL}/ChatSocket`;
